import carouselDigitalSignage from "@/views/digital-signage/carousel-digital-signage/carouselDigitalSignage.vue";
import Loader from "@/components/loader/Loader.vue";
import moment from "moment";
import firebase from "firebase/app";
import { getRegionName } from "@/utils/functionsRegion";
import { RouteGroup } from "@/router/routeGroup";
import Weather from '@/components/weather/Weather.vue';
export default {
    name: "ViewDigitalSignage",
    components: {
        carouselDigitalSignage,
        Weather,
        Loader
    },
    data() {
        return {
            loading: {
                page: true,
                update: false
            },
            location: {
                latitude: null,
                longitude: null
            },
            settings: {
                isShowSidebar: this.digitalSignage?.isShowSidebar ?? true,
                backgroundSidebar: this.digitalSignage?.backgroundSidebar ?? '#3f51b5'
            },
            dialog: false,
            currentTime: '',
            refreshTimeInterval: null,
            deviceParamInterval: 900000,
        };
    },
    async created() {

        if (this.$route.query.staffId) {

            if(this.$store.getters.isAuthenticated && (this.$store.getters.user?.id !== this.$route.query.staffId)) {
                this.$store.dispatch("userSignOut", { noRedirect: true })
                console.log('another user signed in. cleare cache and sign in by custom token')
                await this.signInStaffByCustomToken(this.$route.query.staffId, this.$route.params.facilityId)
            }
            else if(this.$store.getters.isAuthenticated && (this.$store.getters.user?.id === this.$route.query.staffId)) {
                console.log('requested user already signed in. load screen...')
                await this.loadData();
            }
            else{
                console.log('user not signed in. sign in by custom token')
                await this.signInStaffByCustomToken(this.$route.query.staffId, this.$route.params.facilityId)
            }
        }
        else {
            await this.loadData();
            console.log('user signed in by regular token')
        }

    },
    computed: {
        facility() {
            return this.$store.state.authModule.currentFacilityData;
        },
        digitalSignage() {
            return this.$store.state.digitalSignageModule.currentDigitalSignage;
        },
        isResidentChannel() {
            return this.digitalSignage.isResidentChannel;
        },
        currentTimeAndDate() {
            return moment(this.currentTime).format(this.facility.dateFormat + ' '+ this.facility.timeFormat)
        },
        digitalSignageTV() {
            return this.$store.state.digitalSignageModule.digitalSignageTV;
        },
    },
    watch: {
        digitalSignageTV(newValue, oldValue) {
            if(oldValue.isAuth && !newValue.isAuth) {
                this.$store.state.digitalSignageModule.subscribeOnDigitalSignageTV();
                this.$router.push('/digital-signage-tv-QR-code');
            }
        }
    },
    methods: {
       async loadData(){
            await this.$store.dispatch("getFacility");
            await this.$store.dispatch("getDigitalSignage", this.$route.params.id);
            await this.setStyles();
            if(this.settings.isShowSidebar) {
                await this.getLocation();
            }
            this.listenDeviceQueryParams();
            this.loading.page = false;
            this.refreshTimeInterval = setInterval(this.updateCurrentTime, 1000);
        },
        async signInStaffByCustomToken(staffId, facilityId) {
            console.log('sign in by custom token...')
            const result = await firebase.app().functions(getRegionName()).httpsCallable("getUserCustomToken")({
                userId: staffId,
                claims: { sessionType: 'tvDisplay', skipSessionTimeout: true}
                //claims: { accessGroups: [RouteGroup.DigitalSignage], facilityId: facilityId }
            })

            const customToken = result?.data?.customToken;

            if(!customToken?.length) {
                console.error('custom token is invalid')
                this.$router.push('/login');
            }

            console.log('got valid custom token')

            const isSignedIn = await this.$store.dispatch("signInByCustomToken", { customToken: customToken, isExternalPagesViewing: true})

            if(isSignedIn){
                console.log('user signed in by custom token')
                await this.loadData();
            }
            else{
                this.$router.push('/login');
            }
        },
        async getLocation() {
            return new Promise((resolve, reject) => {
                const success = (position) => {
                    this.location.latitude = position.coords.latitude;
                    this.location.longitude = position.coords.longitude;
                    resolve();
                };

                const error = (err) => {
                    if (this.facility.defaultLocation) {
                        this.location.latitude = this.facility.defaultLocation.latitude;
                        this.location.longitude = this.facility.defaultLocation.longitude;
                        resolve();
                    } else {
                        reject(new Error(`Locations error - ${err.message}`));
                    }
                };

                navigator.geolocation.getCurrentPosition(success, error);
            });
        },
        openSettings() {
            this.dialog = true;
        },
        closeSettings() {
            this.dialog = false;
        },
        async updateSettings() {
            this.loading.update = true;
            this.digitalSignage.isShowSidebar = this.settings.isShowSidebar;
            this.digitalSignage.backgroundSidebar = this.settings.backgroundSidebar;
            this.digitalSignage.isShowScreensaver = this.settings.isShowScreensaver;
            this.digitalSignage.backgroundScreensaver = this.settings.backgroundScreensaver;
            this.digitalSignage.fontFamilyScreensaver = this.settings.fontFamilyScreensaver;
            await this.$store.dispatch("saveDigitalSignage", this.digitalSignage);
            await this.$store.dispatch("getDigitalSignage", this.$route.params.id);
            this.loading.update = false;
            this.closeSettings();
        },
        setStyles() {
            this.settings.isShowSidebar = this.digitalSignage?.isShowSidebar ?? true;
            this.settings.backgroundSidebar = this.digitalSignage?.backgroundSidebar ?? '#3f51b5';
        },
        updateCurrentTime() {
            this.currentTime = moment(new Date());
        },
        async listenDeviceQueryParams() {
            const deviceName = this.$route.query.devicename;
            const digitalSignageRef = await firebase
              .firestore()
              .collection("digitalSignage")
              .doc(this.$route.params.id);

            if(deviceName) {
                this.updateDeviceTime(digitalSignageRef, deviceName);
            }

            setInterval(() => {
                if(deviceName) {
                    this.updateDeviceTime(digitalSignageRef, deviceName);
                }
            }, this.deviceParamInterval);
        },
        updateDeviceTime(digitalSignageRef, deviceName) {
            const subCollectionRef = digitalSignageRef.collection('devices');
            const device = {
                deviceName: deviceName,
                geoLocation: [this.location.latitude, this.location.longitude],
                lastCheckin: new Date()
            }

            subCollectionRef.get()
              .then((querySnapshot) => {
                  if(querySnapshot.docs.length) {
                      const deviceId = querySnapshot.docs
                        .filter(x => x.data().deviceName === device.deviceName)
                        .map(x => x.id)[0];

                      if(deviceId && deviceId.length) {
                          subCollectionRef.doc(deviceId).update(device);
                      } else {
                          subCollectionRef.add(device);
                      }

                  } else {
                      subCollectionRef.add(device);
                  }
            }).catch((error) => {
                this.$toast.open({
                    type: "error",
                    message: this.$t("GeneralTranslations.UnhandledError")
                });

                console.log("ERROR ", error.message)
            })
        },
        async updateSidebar(value) {
            if(this.settings?.isShowSidebar !== value?.isShowSidebar) {
                if(!this.location.longitude && !this.location.latitude) {
                    await this.getLocation()
                      .then(() => {
                          this.settings.isShowSidebar = value.isShowSidebar;
                      });
                }
                else {
                    this.settings.isShowSidebar = value.isShowSidebar;
                }
            }
        },
        back() {
            this.$router.push('/digital-signage-tv');
        }
    },
    beforeDestroy() {
        clearInterval(this.refreshTimeInterval);
    },
};
